<template>
    <div class="dark-card card-rounded card-transparent">
        <flash></flash>
        <div class="dark-card-header rounded-t">{{transEdit('availability-schedule')}}</div>
        <div class="dark-card-body pt-0 rounded-b">
            <div class="">
                <button type="button" class="rounded text-white px-8 py-1 " :class="date ? 'bg-tlmblue2 cursor-pointer' : 'bg-gray-500 cursor-default'" @click="addAvailability(date.date)" :disabled="!date">
                    <i class="fa fa-plus"></i> {{transEdit('register-availability')}}</button>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <calendar
                            :ajaxUrl="route_availabilities"
                            date-key="start"
                            @daySelected="setDate"
                            :canSelectEmpty="true"
                            ref="calendar"
                            :disablePastDays="true"
                            :darkHeader="true"
                    ></calendar>
                </div>

                <div class="col-lg-6">
                    <template v-if="date">
                        <h4 class="text-center">{{date.date.format('YYYY-MM-DD')}}</h4>
                        <div>
                            <div v-for="slot in date.events" class="availability-slot rounded border mt-2 mb-2 p-2">
                                <div class="flex-column justify-content-around">
                                    <strong>{{getTime(slot.start)}} - {{getTime(slot.end)}}</strong>
                                </div>
                                <div class="flex-column justify-content-around">
                                    <button @click="deleteAvailability(slot)" class="btn btn-danger"><i class="fa fa-times-circle-o"></i> {{transEdit('remove')}}</button>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import AddAvailabilityModal from './AddAvailabilityModal.vue'
    import DeleteAvailabilityModal from './DeleteAvailabilityModal.vue'

    export default {
        name: "Availability",
        components: {AddAvailabilityModal},
        props: ['route_availabilities', 'route_store_availabilities'],
        data() {
            return {
                date: null,
            }
        },
        methods: {
            getDateTime(dateString){
                return moment(dateString).format('YYYY-MM-DD') + ' kl. ' +  moment(dateString).format('HH:mm')
            },
            getTime(dateString){
                return moment(dateString).format('HH:mm')
            },
            getTimespanSameDate(start, end) {
                let _start = moment(start);
                let _end = moment(end);
                return _start.format('YYYY-MM-DD') + ', ' + _start.format('HH:mm') + ' - ' + _end.format('HH:mm');
            },
            setDate(date) {
                this.date = date;
            },
            closeModal (event) {
                this.$refs.calendar.ajaxEvents();
            },
            addAvailability(date){
                this.$modal.show(AddAvailabilityModal, {
                    'date': date,
                    'route_store': this.route_store_availabilities,
                }, {
                    'width': '100%',
                    'height': 'auto',
                    'max-width': 800,
                    'adaptive': true,
                    'clickToClose': true,
                }, {
                    'before-close': this.closeModal
                })
            },
            deleteAvailability(availability){
                this.$modal.show(DeleteAvailabilityModal, {
                    'availability': availability,
                    'route_delete': this.route_store_availabilities,
                }, {
                    'width': '100%',
                    'height': 'auto',
                    'max-width': 800,
                    'adaptive': true,
                    'clickToClose': true,
                }, {
                    'before-close': this.closeModal
                })
            },

        }
    }
</script>

<style scoped>
    .availability-slot{
        display: flex;
        justify-content: space-between;
    }

</style>